<template>
    <div class="space-y-6">
        <div class="flex items-center justify-between">
            <h2 class="text-heading-md">Money Input Examples</h2>
            <div class="flex items-center gap-4">
                <span class="text-content-md font-medium text-content-secondary">Size:</span>
                <DsRadio
                    v-model="size"
                    label="Medium (default)"
                    name="money-input-size"
                    value="md"
                />
                <DsRadio
                    v-model="size"
                    label="Small"
                    name="money-input-size"
                    value="sm"
                />
            </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <DsMoneyInput
                v-model="defaultTextValue"
                label="Default"
                required
                :size
            />
            <DsMoneyInput
                v-model="infoIconTextValue"
                label="With info icon"
                labelTooltip="Info icon tooltip"
                :size
            />
            <DsMoneyInput
                v-model="prefixTextValue"
                label="With Prefix"
                :moneyConfig="{ prefix: '$' }"
                :size
            />
            <DsMoneyInput
                v-model="negativeTextValue"
                label="Disable Negative"
                :moneyConfig="{ prefix: '$', disableNegative: true }"
                :size
            />
            <DsMoneyInput
                v-model="warningTextValue"
                label="With warning"
                :moneyConfig="{ prefix: '$' }"
                :size
                warning="Warning message"
            />
            <DsMoneyInput
                v-model="errorTextValue"
                error="Amount is required"
                label="With error"
                :moneyConfig="{ prefix: '$' }"
                :size
            />
            <DsMoneyInput
                v-model="helperTextValue"
                helperText="Enter the wire amount"
                label="With helper text"
                :moneyConfig="{ prefix: '$' }"
                :size
            />
            <DsMoneyInput
                v-model="disabledTextValue"
                disabled
                label="Disabled"
                :moneyConfig="{ prefix: '$' }"
                :size
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import DsMoneyInput from '@ds/form/input/DsMoneyInput.vue';
import DsRadio from '@ds/form/input/DsRadio.vue';
import type { DsInputSize } from '@ds/form/input/text/text-input.types';
import { ref } from 'vue';

const size = ref<DsInputSize>('md');

const defaultTextValue = ref(100);
const prefixTextValue = ref(1000);
const negativeTextValue = ref(10000);
const infoIconTextValue = ref(100000);
const warningTextValue = ref(1000);
const errorTextValue = ref(1000);
const helperTextValue = ref(1000);
const disabledTextValue = ref(1000);
</script>
